export default __webpack_public_path__ + "static/media/sports_banner_1.4aa9ecee.png";